import React, { useRef, useEffect } from "react";
import * as Highcharts from "highcharts";
import { toDateByFormat } from "app/shared/utility/tzUtilFunction";

export default function ChronologyChart({ chronologicalEvents }) {
  const chartRef = useRef();

  useEffect(() => {
    console.log(chronologicalEvents);
    
    if (chartRef.current && (chronologicalEvents?.length ?? 0) > 0) {
      Highcharts.chart(chartRef.current, {
        chart: { type: "timeline" },
        accessibility: {
            screenReaderSection: {
              beforeChartFormat:
                "<h5>{chartTitle}</h5>" +
                "<div>{typeDescription}</div>" +
                "<div>{chartSubtitle}</div>" +
                "<div>{chartLongdesc}</div>" +
                "<div>{viewTableButton}</div>",
            },
            point: {
              valueDescriptionFormat:
                "{index}. {point.label}. {point.description}.",
            },
          },
          xAxis: {
            visible: false,
          },
          yAxis: {
            visible: false,
          },
          title: {
            text: "",
          },
          subtitle: {
            text: "",
          },
          colors: [
            "#4185F3",
            "#427CDD",
            "#406AB2",
            "#3E5A8E",
            "#3B4A68",
            "#363C46",
          ],
  
          series: [
            {
              data: (chronologicalEvents ?? [])
                .map((ce, i) => ({
                  ...ce,
                  datetime: toDateByFormat(
                    `${ce.date} ${ce.time}`,
                    "dd/mm/yyyy HH:mm"
                  ),
                }))
                .sort(
                  (a, b) =>
                    (a?.datetime?.getTime?.() || 0) - (b?.datetime?.getTime?.() || 0)
                )
                .map((o) => ({
                  name: o.info_source,
                  label: `${o.info_source}- ${o.date}:${o.time}`,
                  description: o.description,
                })),
            },
          ],
      });
    }
  }, [chronologicalEvents]);

  return <div ref={chartRef}></div>;
}
